export default __webpack_public_path__ + "static/media/Solitary Physical Learner.1d1c9e85.png";